import './App.css';
import {AuthProvider, useAuth} from './context/AuthContext';
import {BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Providers } from "./providers";
import Login from './login/token';
import Home from './auth/pages/home/page';
import Transactions from "./auth/pages/transactions/page";
import PaymentSuccess from "./auth/pages/PaymentSuccess/page";
import {ErrorPage} from "./guest/pages/errorPage";
import {Layout} from "./components/layout/layout";
import { AppModules } from "./modules/index.routes";

function App() {

    function PrivateRoute({ component: Component, validateExtension = false, extensionName = "" }) {
        let { userInfo } = useAuth();

        if (!userInfo) {
            return <ErrorPage/>
        }

        if (validateExtension)
        {
            if(!userInfo.extensions)
                return <ErrorPage message='Error 403: No cuenta con acceso para consultar esta página'/>;
            if(!userInfo.extensions.includes(extensionName))
                return <ErrorPage message='Error 403: No cuenta con acceso para consultar esta página'/>;
        }

        // Renderiza tu componente de página aquí
        return (
            <Layout>
                <Component />
            </Layout>
        );
    }

    return (
        <Router>
            <AuthProvider>
                <Providers>
                    <Routes>
                        <Route path="/login/token/:token" element={<Login/>}/>
                        <Route path="/"             element={<PrivateRoute component={Home}/>}/>
                        <Route path="/Inicio"         element={<PrivateRoute component={Home}/>}/>
                        <Route path="/Transacciones" element={<PrivateRoute component={Transactions}/>}/>
                        <Route path="/Pago/exito" element={<PrivateRoute component={PaymentSuccess}/>}/>
                        <Route path="*" element={<ErrorPage/>}/>
                        {
                            <>
                                {AppModules.flatMap((extension) =>
                                    extension.paths.flatMap((route) => {
                                        const externalRoute = (
                                            <Route
                                                key={route.path}
                                                path={route.path}
                                                element={
                                                    <PrivateRoute
                                                        component={route.component}
                                                        validateExtension={true}
                                                        extensionName={extension.name}
                                                    />
                                                }
                                            />
                                        );

                                        const internalRoutes = (route.innerPaths || []).map((inner) => (
                                            <Route
                                                key={inner.path}
                                                path={inner.path}
                                                element={
                                                    <PrivateRoute
                                                        component={inner.component}
                                                        validateExtension={true}
                                                        extensionName={extension.name}
                                                    />
                                                }
                                            />
                                        ));

                                        return [externalRoute, ...internalRoutes];
                                    })
                                )}
                            </>
                        }
                        {/* Esta ruta capturará cualquier ruta no definida anteriormente */}
                    </Routes>
              </Providers>
          </AuthProvider>
      </Router>
    );
}

export default App;
